<template>
  <div class="adspace container">
    <ins
      class="adsbygoogle"
      style="display: block"
      data-ad-client="ca-pub-2292705730484150"
      data-ad-slot="3103974598"
      data-ad-format="auto"
      data-full-width-responsive="true"
    ></ins>
  </div>
</template>

<style scoped>
.adspace {
  max-height: 100px;
  margin-bottom: 15px;
}
</style>
